export default "__VITE_ASSET__DWxd$gng__"